import { render } from "./TaskRender.vue?vue&type=template&id=1eaa3efe&scoped=true"
import script from "./TaskRender.vue?vue&type=script&lang=js"
export * from "./TaskRender.vue?vue&type=script&lang=js"

import "./TaskRender.vue?vue&type=style&index=0&id=1eaa3efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eaa3efe"]])

export default __exports__